import Common from '@/assets/js/common'
// import DataDictionary from '@/assets/js/utils/data-dictionary'

/*
 * 把其他filter放到index.js里面一起引入
 */
export default {
  m2km(value) {
    return Common.m2km(value)
  },

  /**
   * 除法
   * @param  {Number} dividend 被除数
   * @param  {Number} divisor  除数
   * @return {Number}          值
   */
  divide(dividend, divisor) {
    return Common.divide(dividend, divisor)
  },

  /**
   * 保留小数位，替代Number.toFixed()方法，针对于某些数据（16.455）不能做到四舍五入
   * @param  {[type]} value 数值
   * @param  {[type]} num   几位小数
   * @return {[type]}       值
   */
  toFixed(value, num) {
    return Common.toFixed(value, num)
  },

  /**
   * 如果是小数则保留小数位，默认两位
   * @param  {[type]} value 数值
   * @param  {Number} num   几位小数
   * @return {[type]}       值
   */
  toFloatFixed(value, num) {
    Common.toFloatFixed(value, num)
  },

  /**
   * 转化成工作时间
   * @param  {[type]} value 值
   * @return {[type]}       [description]
   */
  businessHour(value) {
    let time = ''
    if (value) {
      const arr = value.split(';')
      time =
        '星期' +
        Common.getWeek(arr[0]) +
        ' ~ 星期' +
        Common.getWeek(arr[1]) +
        '  ' +
        Common.getTime(arr[2]) +
        ':' +
        Common.getTime(arr[3]) +
        ' ~ ' +
        Common.getTime(arr[4]) +
        ':' +
        Common.getTime(arr[5])
    }
    return time
  },

  isEmptyObject(o) {
    return Common.isEmptyObject(o)
  },
  wan(value) {
    const isNumber = typeof value === 'number'
    return isNumber && value / 10000
  },
  // 除以100保留小数位
  divide100(value, num = 2, isFill) {
    let values = Number(value)
    const regular = /^\d+\.\d+/
    if (values) {
      values = values / 100
      if (regular.test(values)) {
        return Common.toFixed(values, num)
      } else {
        return Common.toFixed(values)
      }
    } else {
      if (isFill) {
        // 是否需要填充
        value = 0
      }
    }
    return value
  },
  discount(value, position = 0) {
    let ret = value.split('.')
    if (position == 0) {
      ret = ret[0]
    } else if (position == 1) {
      ret = ret[1]
    }
    return ret
  },
  // 数据字典 id 转 text
  idToText(id, type) {
    let text = ''
    let data = JSON.parse(window.localStorage.getItem('enumeration'))
    if(data){
      let obj = data.pathMap[type] || data.pathCommMap[type]
      obj.some(item => {
        if (item.code == id) {
          text = item.value
        }
      })
      
    return text
    }
    
  },
  codeToText(code, type) {
    let text = ''
    let data = {
      customerSource: [
        {
          code: 0,
          value: '转介绍'
        },
        {
          code: 1,
          value: '缘故'
        },
        {
          code: 2,
          value: '陌生'
        }
      ],
      customerType: [
        {
          code: 0,
          value: '准客户'
        },
        {
          code: 1,
          value: '老客户'
        }
      ]
    }
    data[type].some(item => {
      if (item.code == code) {
        text = item.value
      }
    })
    return text
  },
  /**
   * 处理千分位并保留两位小数
   * @param  {[type]} moneyStr 钱
   * @param  {Boolean} flag     是否保留两位小数
   * @return {[type]}          值
   */
  // 处理钱的格式
  moneyFormat(moneyStr, flag = false) {
    // let str = (Math.round(moneyStr * 100) / 100).toString()
    // let pointIdx = str.indexOf('.')
    // if (pointIdx < 0) {
    //   str = str.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
    //   pointIdx = str.length
    //   str += '.'
    // } else {
    //   let int = str.substr(0, pointIdx)
    //   int.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
    // }
    // while (str.length <= pointIdx + 2) {
    //   str += '0'
    // }

    // return str
    let str = ''
    if (flag) {
      str = (moneyStr + '').replace(/\d{1,3}(?=(\d{3})+$)/g, '$&,')
    } else {
      str = parseFloat(moneyStr)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
    }
    return str
  },
  // 处理保额的格式化
  amtFormat(moneyStr) {
    let str = ''
    str = (moneyStr + '').replace(/\d{1,3}(?=(\d{3})+$)/g, '$&,')
    return str
  },
  // 过万处理
  million(value) {
    let num
    if (value > 9999) {
      num = (Math.floor(value / 1000) / 10) + '万'
    } else if (value < 9999 && value > -9999) {
      num = value
    } else if (value < -9999) {
      num = -(Math.floor(Math.abs(value) / 1000) / 10) + '万'
    }
    return num
  },
  // 名称过长截取
  strLen(value, len) {
    if (!value) return ''
    if (value.length > len) {
      return value.slice(0, len) + '...'
    }
    return value
  }
}
